import CountUpModule from 'react-countup';

/**
 * `CountUp` aus `react-countup` — gemeinsame Auflösung für alle vier Aufrufstellen der Frontends.
 *
 * Das Paket liefert ausschliesslich CommonJS (`main: "build"`, `exports.default`, `__esModule`)
 * und kein ESM-Feld. Je nach Interop ist der Default-Import deshalb entweder die Komponente
 * selbst (Vite-Dev-Server) oder der ganze `exports`-Block (Node/Vitest und der Rolldown-Build,
 * der daraus `__toESM(require('react-countup'), 1)` erzeugt). Im zweiten Fall rendert
 * `<CountUp />` ein Objekt und React bricht mit #130 ab ("expected a string ... but got:
 * object"). Der Ausdruck deckt beide Formen ab.
 */
export const resolveCountUp = (candidate) => (candidate && candidate.default ? candidate.default : candidate);

const CountUp = resolveCountUp(CountUpModule);

export default CountUp;
